export default "__VITE_ASSET__7192e55e__"